export var getWithDefault = function getWithDefault(value, defaultValue) {
  return value === undefined ? defaultValue : value;
};